import { defineMessages } from 'react-intl';

export default defineMessages({
  recapPageTitle: {
    id: 'recap_page.title',
  },
  openingManagerrecapPageTitle: {
    id: 'manager_page.recap_page.title',
  },
  successDialogGoBackToHomePage: {
    id: 'recap_page.preopen_claim_success_dialog.back_to_home_page',
  },
  successDialogPreopenAnotherClaim: {
    id: 'recap_page.preopen_claim_success_dialog.preopen_another_claim',
  },
  successDialogMessage: {
    id: 'recap_page.preopen_claim_success_dialog.message',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  successButtonFeeNote: {
    id: 'success_dialog.fee_note',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  AvocatMissione: {
    id: 'manager_home_page.last_assigned_claims_table_fields.assigned_lawyer',
  },
  openingManagerConfirmationDialogTitle: {
    id: 'opening_manager.confirmation.title',
  },
  openingManagerConfirmationDialogDescription: {
    id: 'opening_manager.confirmation.dialog.description',
  },
  openingManagerConfirmationDialogConfirm: {
    id: 'opening_manager.confirmation.dialog.confirm',
  },
  openingManagerConfirmationDialogCancel: {
    id: 'opening_manager.confirmation.dialog.cancel',
  },
  openingManagerConfirmationDialogSubDescription: {
    id: 'opening_manager.confirmation.dialog.sub_description',
  },
  preopeningManagerConfirmationDialogTitle: {
    id: 'preopening_manager.confirmation.title',
  },
  preopeningManagerConfirmationDialogDescription: {
    id: 'preopening_manager.confirmation.dialog.description',
  },
  preopeningManagerConfirmationDialogConfirm: {
    id: 'preopening_manager.confirmation.dialog.confirm',
  },
  preopeningManagerConfirmationDialogCancel: {
    id: 'preopening_manager.confirmation.dialog.cancel',
  },
  preopeningManagerConfirmationDialogSubDescription: {
    id: 'preopening_manager.confirmation.dialog.sub_description',
  },
  preOpeningManagerProviderDialogDescription: {
    id: 'preopening_manager.provider_dialog.description',
  },
  courtManagerDialogDescription: {
    id: 'court_manager.confirmation.dialog.description',
  },
  courtManagerDialogSubDescription: {
    id: 'court_manager.confirmation.dialog.sub_description',
  },
  preOpeningManagerProviderDialogTitle: {
    id: 'preopening_manager.provider.title',
  },
  preOpeningManagerProviderDialogInput: {
    id: 'preopening_manager.provider_dialog.input',
  },
  preOpeningManagerProviderDialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  preOpeningManagerProviderDialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  dateCompletion: {
    id: 'preopening_manager.provider.date_completion',
  },
  dateReception: {
    id: 'preopening_manager.provider.date_reception',
  },
  dateCompletionError: {
    id: 'preopening_manager.provider.date_completion.date_error',
  },
  dateReceptionError: {
    id: 'preopening_manager.provider.date_reception.date_error',
  },
  type: {
    id: 'expertise.table_header_titles.type',
  },
  otherTitle: {
    id: 'manager_recap_page_rejection.other_reason',
  },
  firmReference: {
    id: 'fee_note.firm_reference',
  },
  dateReceptionProviderLawyerError: {
    id: 'preopening_manager.provider_lawyer.date_reception.date_error',
  },
  errorInfoClaim: {
    id: 'claim.error_missing_info',
  },
  lawyerSuccess: {
    id: 'opening_gpo.lawyer.success_message',
  },
  providerSuccess: {
    id: 'opening_gpo.provider.success_message',
  },
  otherSuccess: {
    id: 'opening_gpo.others.success_message',
  },
  amountTtcTitle: {
    id: 'add_fee_note.dialog.amount_ttc.title',
  },
  addFeeNote: {
    id: 'fee_note.drawer_title',
  },
  costsDialogTitle: {
    id: 'preopening_manager.costs.title',
  },
  comment: {
    id: 'fee_note.comment',
  },
  documentType: {
    id: 'fee_note.document_type',
  },
  feeNoteFrais: {
    id: 'fee_note.frais',
  },
  failCallBackMessage: {
    id: 'opening_gpo.others.fail_message',
  },
  invoiceTitle: {
    id: 'invoice.dialog_info.title',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  warningInvoiceDateManager: {
    id: 'invoice.dialog_info.limit_invoice_date.manager_warning',
  },
  errorInvoiceDateIntervenant: {
    id: 'invoice.dialog_info.limit_invoice_date.intervenant.error',
  },
});
